import { render, staticRenderFns } from "./appendix-home-pay-later.vue?vue&type=template&id=068c25bf&scoped=true"
import script from "./appendix-home-pay-later.vue?vue&type=script&lang=js"
export * from "./appendix-home-pay-later.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c25bf",
  null
  
)

export default component.exports